module.exports = __webpack_public_path__ + "static/media/20151231419.b2a1c298.jpg";